/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import * as Styles from '@components/modals/styles';
import { captureException } from '@sentry/nextjs';
import { RootState } from '@state/store';
import { AlertDialog, Button, Code, Text } from '@versumstudios/ui';

export interface IErrorWarning {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  message?: string;
  error?: any;
  callback?: () => void;
}

export const ErrorWarning: FC<IErrorWarning> = ({ open, onOpenChange, message, error, callback }) => {
  const { general } = useSelector((state: RootState) => state.settings);

  const handleContinue = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }

    if (callback) {
      callback();
    }
  };

  useEffect(() => {
    // if user allows for crash reports send it to sentry
    if (general.crashreport) {
      captureException(error);
    }
  }, []);

  return (
    <AlertDialog title="Error" description={message} open={open} onOpenChange={handleContinue}>
      <Styles.Content>
        <Text unset css={{ color: '$secondaryFill', fontSize: 14 }}>
          Copy the error stack below and report on{' '}
          <Button as="a" variant="underline" href="https://t.co/Pt1QuvBtbJ" target="_blank" rel="noopener noreferrer">
            Discord
          </Button>{' '}
          or{' '}
          <Button
            as="a"
            variant="underline"
            href="https://github.com/versumstudios/report-issues/issues/new?assignees=&labels=&template=bug_report.md"
            target="_blank"
            rel="noopener noreferrer"
          >
            Github
          </Button>
          .
        </Text>
        {error && <Code>{error}</Code>}
      </Styles.Content>
    </AlertDialog>
  );
};
